export default __webpack_public_path__ + "static/media/img_modal_login.c0fe37e8.svg";